import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { fwHttpClientUtils } from '@myapp/modules/fwcore/models';
import { RequestDelete, ResponseDelete } from '@myapp/modules/fwcore/models/messages';
import { BaseHttpReqRespService, BaseHttpService } from '@myapp/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import urlJoin from 'url-join';
import { IInstanceConfiguration } from '../../admin/models/future-deprecation/IInstanceConfiguration'
import { ICompany, IUser, License, Module } from '../models';
@Injectable({
  providedIn: 'root'
})
export class PowerBIIntegrationService extends BaseHttpReqRespService {
  [x: string]: any;

  /*-------------------------- Internal properties  ---------------------------*/

  readonly instanceEndpoint: string = 'instanceconfiguration';
  readonly instanceByNameEndpoint: string = 'instanceconfiguration/GetConfigurationByName';
  readonly upsertInstanceConfiguration: string = 'instanceconfiguration/UpsertInstanceConfiguration';


  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) protected auth: OktaAuth
    , @Inject('CONFIG_SETTINGS') private config: any) {

    super(http, auth);

    const configSettings = config['general'];
    this.baseUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    this.powerBIAPIKey = configSettings['powerBIAPIKey'];
   
  }

  /*-------------------------- public properties / methods --------------------*/

  getPowerBIReportDetails(): Observable<ResponseReportEmbed | null> {
    const configSettings = this.config['general'];
    const powerBIReportURL = configSettings['powerBIReportURL'];
    const pbiWorkSpaceId = configSettings['pbiWorkSpaceId'];
    const pbiChartId = configSettings['pbiChartId'];
    const pbiPageSection = configSettings['pbiPageSection'];
    const pbiNavigation = configSettings['pbiNavigation'];
    const roles = configSettings['roles'];
    const userEmail = configSettings['userEmail'];

    const powerBIReportRequest  = {     
      pbiWorkSpaceId: pbiWorkSpaceId,
      pbiChartId: pbiChartId,
      pbiPageSection: pbiPageSection,
      pbiNavigation: pbiNavigation,
      roles: roles,
      userEmail: userEmail
    };

    const token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.upsertInstanceConfiguration);
      try {
        return this.saveItem(powerBIReportRequest, true, powerBIReportURL, this.getHttpBearerPBHeaders(token)) as any as Observable<ResponseReportEmbed>;
      } catch (e) {
        return of(null);
      }
    } else {
      return of(null);
    }
  }


}




export class ResponseReportEmbed {
  id?: string;
  name?: string | null;
  title?: string | null;

  embedType?: string;
  embedUrl?: string;
  embedToken?: EmbedToken;
  minutesToExpiration?: number | null;

  isEffectiveIdentityRolesRequired?: boolean | null;
  isEffectiveIdentityRequired?: boolean | null;

  enableRLS?: boolean | null;
  username?: string | null;
  roles?: string | null;
  errorMessage?: string | null;

  dashboardHierarchyId?: string | null;
  fixedHeight?: number | null;
  chart?: any | null;
}

export class EmbedToken {
  token?: string;
  tokenId?: string | null;
  expiration?: Date | null;
}
